const objectMapper = require("object-mapper");

const Mapper = function (src, map) {
  return objectMapper(src, map);
}

module.exports = { Mapper };